import React from 'react'

const RightAlignment = (props) =>{
    return(
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 3H2" stroke={props.color ? props.color : "#7D8492"} stroke-opacity={props.strokeOpacity ? props.strokeOpacity : "0.6"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M14 6.33325H7.68667" stroke={props.color ? props.color : "#7D8492"} stroke-opacity={props.strokeOpacity ? props.strokeOpacity : "0.6"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M14 9.66675H2" stroke={props.color ? props.color : "#7D8492"} stroke-opacity={props.strokeOpacity ? props.strokeOpacity : "0.6"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M14 13H7.68667" stroke={props.color ? props.color : "#7D8492"} stroke-opacity={props.strokeOpacity ? props.strokeOpacity : "0.6"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>

    )
}
export default RightAlignment;
